import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=2ca0935b&scoped=true&"
import script from "./SecondaryButton.vue?vue&type=script&lang=js&"
export * from "./SecondaryButton.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&id=2ca0935b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0935b",
  null
  
)

export default component.exports